import { render } from "./index.vue?vue&type=template&id=915b0d84&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=915b0d84&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-915b0d84"

export default script